module.exports = __webpack_public_path__ + "static/img/bc-3.b5e2907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc-3.png
// module id = kQ8G
// module chunks = 0